// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .navbar-left {
    display: flex;
    align-items: center;
  }
  
  .hamburger-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0.5rem;
    margin-right: 1rem;
  }
  
  .hamburger-btn:hover {
    opacity: 0.8;
  }
  

.navbar {
    position: fixed !important;
    top: 0;
    left: 250px;
    right: 0;
    height: 60px;
    background-color: var(--primary-grey);
    color: var(--primary-yellow);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 var(--spacing-xl);
    z-index: 1000;
    box-shadow: var(--shadow-sm);
    transition: left 0.3s ease;
  }
  .sidebar-collapsed .navbar {
    left: 58px;
  }
  .welcome-text {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
  
  .profile-dropdown {
    position: relative;
    cursor: pointer;
    border: 1px solid #fff;
    margin-right: 10px;
    border-radius: 8px;
  }
  
  .profile-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    padding: 3px;
    padding-left: 5px;
    padding-right: 5px;
  }
  
  .profile-btn i:last-child {
    margin-left: 0.25rem;
  }
  
  .dropdown-content {
    position: absolute;
    right: 0;
    top: 100%;
    background-color: var(--primary-grey);
    min-width: 180px;
    box-shadow: var(--shadow-md);
    border-radius: 4px;
    overflow: hidden;
    z-index: 1000;
  }
  
  .dropdown-content a {
  
    color: #fff;
    padding: 0.75rem 1rem;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: background-color 0.3s ease;
  }
  
  .dropdown-content a:hover {
    background-color: var(--secondary-grey);
  }
  
  .dropdown-content i {
    width: 20px;
    text-align: center;
  }
  
  @media (max-width: 768px) {
    .navbar {
      left: 0;
    }
    .sidebar-collapsed .navbar {
      left: 0px !important;
  }
  } */


  .navbar-left {
    display: flex;
    align-items: center;
  }
   
  .hamburger-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 1.2rem;
    cursor: pointer;
    padding: 0.5rem;
    margin-right: 1rem;
  }
   
  .hamburger-btn:hover {
    opacity: 0.8;
  }
   
  .navbar {
    position: fixed !important;
    top: 0;
    left: 250px;
    right: 0;
    height: 60px;
    background-color: var(--primary-grey);
    color: var(--primary-yellow);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 var(--spacing-xl);
    z-index: 1000;
    box-shadow: var(--shadow-sm);
    transition: left 0.3s ease;
  }
  .sidebar-collapsed .navbar {
    left: 60px;
  }
  .welcome-text {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
  }
   
  .profile-dropdown {
    position: relative;
    cursor: pointer;
    border: 1px solid #fff;
    margin-right: 10px;
    border-radius: 8px;
  }
   
  .profile-btn {
    background: none;
    border: none;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
   
    padding: 3px;
    padding-left: 5px;
    padding-right: 5px;
  }
   
  .profile-btn i:last-child {
    margin-left: 0.25rem;
  }
   
  .dropdown-content {
    position: absolute;
    right: 0;
    top: 100%;
    background-color: var(--primary-grey);
    min-width: 180px;
    box-shadow: var(--shadow-md);
    border-radius: 4px;
    overflow: hidden;
    z-index: 1000;
  }
   
  .dropdown-content a {
    color: #fff;
    padding: 0.75rem 1rem;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: background-color 0.3s ease;
  }
   
  .dropdown-content a:hover {
    background-color: var(--secondary-grey);
  }
   
  .dropdown-content i {
    width: 20px;
    text-align: center;
  }
   
  @media (max-width: 768px) {
    .navbar {
      left: 0;
      padding: 0 var(--spacing-md);
    }
    .sidebar-collapsed .navbar {
      left: 0;
    }
    .welcome-text {
      font-size: 14px;
    }
    .profile-dropdown {
      margin-right: 5px;
    }
    .profile-btn {
      font-size: 12px;
      padding: 2px 4px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/components/navbar.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA+GK;;;EAGH;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,0BAA0B;IAC1B,MAAM;IACN,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,qCAAqC;IACrC,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,4BAA4B;IAC5B,0BAA0B;EAC5B;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,WAAW;;IAEX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qCAAqC;IACrC,gBAAgB;IAChB,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE;MACE,OAAO;MACP,4BAA4B;IAC9B;IACA;MACE,OAAO;IACT;IACA;MACE,eAAe;IACjB;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;MACf,gBAAgB;IAClB;EACF","sourcesContent":["/* .navbar-left {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .hamburger-btn {\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    font-size: 1.2rem;\r\n    cursor: pointer;\r\n    padding: 0.5rem;\r\n    margin-right: 1rem;\r\n  }\r\n  \r\n  .hamburger-btn:hover {\r\n    opacity: 0.8;\r\n  }\r\n  \r\n\r\n.navbar {\r\n    position: fixed !important;\r\n    top: 0;\r\n    left: 250px;\r\n    right: 0;\r\n    height: 60px;\r\n    background-color: var(--primary-grey);\r\n    color: var(--primary-yellow);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0 var(--spacing-xl);\r\n    z-index: 1000;\r\n    box-shadow: var(--shadow-sm);\r\n    transition: left 0.3s ease;\r\n  }\r\n  .sidebar-collapsed .navbar {\r\n    left: 58px;\r\n  }\r\n  .welcome-text {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #fff;\r\n  }\r\n  \r\n  .profile-dropdown {\r\n    position: relative;\r\n    cursor: pointer;\r\n    border: 1px solid #fff;\r\n    margin-right: 10px;\r\n    border-radius: 8px;\r\n  }\r\n  \r\n  .profile-btn {\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    \r\n    padding: 3px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n  \r\n  .profile-btn i:last-child {\r\n    margin-left: 0.25rem;\r\n  }\r\n  \r\n  .dropdown-content {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 100%;\r\n    background-color: var(--primary-grey);\r\n    min-width: 180px;\r\n    box-shadow: var(--shadow-md);\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .dropdown-content a {\r\n  \r\n    color: #fff;\r\n    padding: 0.75rem 1rem;\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .dropdown-content a:hover {\r\n    background-color: var(--secondary-grey);\r\n  }\r\n  \r\n  .dropdown-content i {\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    .navbar {\r\n      left: 0;\r\n    }\r\n    .sidebar-collapsed .navbar {\r\n      left: 0px !important;\r\n  }\r\n  } */\r\n\r\n\r\n  .navbar-left {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n   \r\n  .hamburger-btn {\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    font-size: 1.2rem;\r\n    cursor: pointer;\r\n    padding: 0.5rem;\r\n    margin-right: 1rem;\r\n  }\r\n   \r\n  .hamburger-btn:hover {\r\n    opacity: 0.8;\r\n  }\r\n   \r\n  .navbar {\r\n    position: fixed !important;\r\n    top: 0;\r\n    left: 250px;\r\n    right: 0;\r\n    height: 60px;\r\n    background-color: var(--primary-grey);\r\n    color: var(--primary-yellow);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 0 var(--spacing-xl);\r\n    z-index: 1000;\r\n    box-shadow: var(--shadow-sm);\r\n    transition: left 0.3s ease;\r\n  }\r\n  .sidebar-collapsed .navbar {\r\n    left: 60px;\r\n  }\r\n  .welcome-text {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #fff;\r\n  }\r\n   \r\n  .profile-dropdown {\r\n    position: relative;\r\n    cursor: pointer;\r\n    border: 1px solid #fff;\r\n    margin-right: 10px;\r\n    border-radius: 8px;\r\n  }\r\n   \r\n  .profile-btn {\r\n    background: none;\r\n    border: none;\r\n    color: #fff;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n   \r\n    padding: 3px;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n   \r\n  .profile-btn i:last-child {\r\n    margin-left: 0.25rem;\r\n  }\r\n   \r\n  .dropdown-content {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 100%;\r\n    background-color: var(--primary-grey);\r\n    min-width: 180px;\r\n    box-shadow: var(--shadow-md);\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    z-index: 1000;\r\n  }\r\n   \r\n  .dropdown-content a {\r\n    color: #fff;\r\n    padding: 0.75rem 1rem;\r\n    text-decoration: none;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n   \r\n  .dropdown-content a:hover {\r\n    background-color: var(--secondary-grey);\r\n  }\r\n   \r\n  .dropdown-content i {\r\n    width: 20px;\r\n    text-align: center;\r\n  }\r\n   \r\n  @media (max-width: 768px) {\r\n    .navbar {\r\n      left: 0;\r\n      padding: 0 var(--spacing-md);\r\n    }\r\n    .sidebar-collapsed .navbar {\r\n      left: 0;\r\n    }\r\n    .welcome-text {\r\n      font-size: 14px;\r\n    }\r\n    .profile-dropdown {\r\n      margin-right: 5px;\r\n    }\r\n    .profile-btn {\r\n      font-size: 12px;\r\n      padding: 2px 4px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
